@use 'styles/mixins';
@use 'styles/variables';

.Container {
  width: 100%;

  &_Header {
    @include mixins.flex-align-center;
    justify-content: space-between;

    margin-bottom: 4rem;
  }

  &_TitleWrapper {
    max-width: 70%;

    overflow: hidden;

    text-overflow: ellipsis;
  }

  &_Buttons {
    @include mixins.flex-align-center;
  }

  &_HeaderTextWrapper {
    width: 100%;
    max-width: 70.2rem;
  }
}

.TitleWrapperExtra {
  display: flex;
  align-items: baseline;
}

.WithSmallerMargin {
  margin-bottom: 3.2rem;

  overflow-wrap: anywhere;
  word-break: normal;
}

@include mixins.forScreen(
  variables.$mobile-small-width,
  variables.$desktop-width - 1
) {
  .Container {
    &_Header {
      margin-bottom: 1.5rem;

      & span {
        font-size: 2rem;
      }
    }

    &_Buttons {
      display: none;
    }
  }
}
